/**
 * Helpers de presentación del dominio Talonarios (formato + traducción de error).
 *
 * Puro formato/traducción para la UI; sin lógica de negocio ni acceso a la API.
 * Las fechas llegan del backend en ISO/local Colombia (`progress/
 * explore_talonarios_api.md`, §2), así que aquí solo se acortan; no se
 * reinterpreta la zona.
 */
import { ApiError } from "@/lib/api";

import { TALONARIO_ERROR_MESSAGE } from "./constants";

/**
 * Acorta un ISO datetime a "YYYY-MM-DD HH:MM" para mostrar; una `date` pura (sin
 * "T") se deja tal cual. Devuelve "—" si el valor es nulo/vacío.
 */
export function formatDateTime(value: string | null): string {
  if (!value) {
    return "—";
  }
  const [date, time] = value.split("T");
  if (!time) {
    return date;
  }
  return `${date} ${time.slice(0, 5)}`;
}

/** Muestra una fecha (o "—" si es nula). */
export function formatDate(value: string | null): string {
  if (!value) {
    return "—";
  }
  return value.split("T")[0];
}

/**
 * Traduce un error de la API/red a un mensaje legible para el usuario. Usa el
 * diccionario por `error_code` (`TALONARIO_ERROR_MESSAGE`) y, si el código no
 * está mapeado, cae al `message` del `ApiError` (ya en español del backend).
 */
export function talonarioErrorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    return TALONARIO_ERROR_MESSAGE[error.error_code] ?? error.message;
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return "Ocurrió un error inesperado.";
}

/** Porcentaje de uso de un talonario (0–100), redondeado, dado total y ocupados. */
export function usagePercent(occupied: number, total: number): number {
  if (total <= 0) {
    return 0;
  }
  return Math.round((occupied / total) * 100);
}
